/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './paramedic-referral-charge.reducer';

export const ParamedicReferralChargeDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const paramedicReferralChargeEntity = useAppSelector(state => state.paramedicReferralCharge.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="paramedicReferralChargeDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.paramedicReferralCharge.detail.title">ParamedicReferralCharge</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.paramedicReferralCharge.id">Id</Translate>
            </span>
          </dt>
          <dd>{paramedicReferralChargeEntity.id}</dd>
          <dt>
            <span id="charge">
              <Translate contentKey="tinyMedicRestApp.paramedicReferralCharge.charge">Charge</Translate>
            </span>
          </dt>
          <dd>{paramedicReferralChargeEntity.charge}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.paramedicReferralCharge.active">Active</Translate>
            </span>
          </dt>
          <dd>{paramedicReferralChargeEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.paramedicReferralCharge.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{paramedicReferralChargeEntity.cursor}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.paramedicReferralCharge.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{paramedicReferralChargeEntity.microSec}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.paramedicReferralCharge.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{paramedicReferralChargeEntity.lastUpdated}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.paramedicReferralCharge.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{paramedicReferralChargeEntity.timestampEntry}</dd>
          <dt>
            <span id="referralChargeType">
              <Translate contentKey="tinyMedicRestApp.paramedicReferralCharge.referralChargeType">Referral Charge Type</Translate>
            </span>
          </dt>
          <dd>{paramedicReferralChargeEntity.referralChargeType}</dd>
          <dt>
            <span id="addedByType">
              <Translate contentKey="tinyMedicRestApp.paramedicReferralCharge.addedByType">Added By Type</Translate>
            </span>
          </dt>
          <dd>{paramedicReferralChargeEntity.addedByType}</dd>
          <dt>
            <span id="addedByID">
              <Translate contentKey="tinyMedicRestApp.paramedicReferralCharge.addedByID">Added By ID</Translate>
            </span>
          </dt>
          <dd>{paramedicReferralChargeEntity.addedByID}</dd>
          <dt>
            <span id="modifiedByType">
              <Translate contentKey="tinyMedicRestApp.paramedicReferralCharge.modifiedByType">Modified By Type</Translate>
            </span>
          </dt>
          <dd>{paramedicReferralChargeEntity.modifiedByType}</dd>
          <dt>
            <span id="modifiedByID">
              <Translate contentKey="tinyMedicRestApp.paramedicReferralCharge.modifiedByID">Modified By ID</Translate>
            </span>
          </dt>
          <dd>{paramedicReferralChargeEntity.modifiedByID}</dd>
          <dt>
            <span id="emergencyHike">
              <Translate contentKey="tinyMedicRestApp.paramedicReferralCharge.emergencyHike">Emergency Hike</Translate>
            </span>
          </dt>
          <dd>{paramedicReferralChargeEntity.emergencyHike}</dd>
          <dt>
            <span id="hishRiskHike">
              <Translate contentKey="tinyMedicRestApp.paramedicReferralCharge.hishRiskHike">Hish Risk Hike</Translate>
            </span>
          </dt>
          <dd>{paramedicReferralChargeEntity.hishRiskHike}</dd>
          <dt>
            <span id="emergencyHikeType">
              <Translate contentKey="tinyMedicRestApp.paramedicReferralCharge.emergencyHikeType">Emergency Hike Type</Translate>
            </span>
          </dt>
          <dd>{paramedicReferralChargeEntity.emergencyHikeType}</dd>
          <dt>
            <span id="hishRiskHikeType">
              <Translate contentKey="tinyMedicRestApp.paramedicReferralCharge.hishRiskHikeType">Hish Risk Hike Type</Translate>
            </span>
          </dt>
          <dd>{paramedicReferralChargeEntity.hishRiskHikeType}</dd>
          <dt>
            <span id="startDate">
              <Translate contentKey="tinyMedicRestApp.paramedicReferralCharge.startDate">Start Date</Translate>
            </span>
          </dt>
          <dd>{paramedicReferralChargeEntity.startDate}</dd>
          <dt>
            <span id="endDate">
              <Translate contentKey="tinyMedicRestApp.paramedicReferralCharge.endDate">End Date</Translate>
            </span>
          </dt>
          <dd>{paramedicReferralChargeEntity.endDate}</dd>
          <dt>
            <span id="suspended">
              <Translate contentKey="tinyMedicRestApp.paramedicReferralCharge.suspended">Suspended</Translate>
            </span>
          </dt>
          <dd>{paramedicReferralChargeEntity.suspended ? 'true' : 'false'}</dd>
          <dt>
            <span id="draft">
              <Translate contentKey="tinyMedicRestApp.paramedicReferralCharge.draft">Draft</Translate>
            </span>
          </dt>
          <dd>{paramedicReferralChargeEntity.draft ? 'true' : 'false'}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.paramedicReferralCharge.doctor">Doctor</Translate>
          </dt>
          <dd>{paramedicReferralChargeEntity.doctor ? paramedicReferralChargeEntity.doctor.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.paramedicReferralCharge.hospital">Hospital</Translate>
          </dt>
          <dd>{paramedicReferralChargeEntity.hospital ? paramedicReferralChargeEntity.hospital.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.paramedicReferralCharge.scheme">Scheme</Translate>
          </dt>
          <dd>{paramedicReferralChargeEntity.scheme ? paramedicReferralChargeEntity.scheme.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.paramedicReferralCharge.procedure">Procedure</Translate>
          </dt>
          <dd>{paramedicReferralChargeEntity.procedure ? paramedicReferralChargeEntity.procedure.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.paramedicReferralCharge.paramedic">Paramedic</Translate>
          </dt>
          <dd>{paramedicReferralChargeEntity.paramedic ? paramedicReferralChargeEntity.paramedic.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/paramedic-referral-charge" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/paramedic-referral-charge/${paramedicReferralChargeEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ParamedicReferralChargeDetail;
